import React from 'react';

export const SectionLabel = ({ children, align = 'left', dark = false }) => (
  <div className={`flex items-center gap-3 ${align === 'center' ? 'justify-center' : ''}`}>
    <span className={`block w-10 h-px ${dark ? 'bg-[#c3a66d]' : 'bg-[#c3a66d]'}`} />
    <span className={`eyebrow ${dark ? 'text-[#c3a66d]' : 'text-[#a6894f]'}`}>{children}</span>
  </div>
);

export const Heading = ({ children, as: As = 'h2', className = '', dark = false }) => (
  <As className={`serif-hero ${dark ? 'text-[#ffeabf]' : 'text-[#053e49]'} text-4xl md:text-5xl lg:text-6xl ${className}`}>{children}</As>
);

export const Hairline = ({ className = '' }) => <div className={`hairline ${className}`} />;

export const Pill = ({ children }) => (
  <span className="inline-flex items-center gap-2 border border-[#c3a66d]/50 text-[#a6894f] px-3 py-1 rounded-full eyebrow">{children}</span>
);
